import React from 'react';
import LivePlatFormFilter from '@sg/components/LivePlatFormFilter';
import LiveRegionFilter from '@sg/components/LiveRegionFilter';
import LiveMonthFilter from '@sg/components/LiveMonthFilter';
import { useLiveTitleCond } from '@sg/pages/StudioManagement/LiveTitles/hooks';
import './index.scss';

const Filter: React.FC = (props: any) => {
  const {
    selectedDate,
    selectedTitle,
    selectedRegion,
    selectedPlatforms,
    gameTitle,
    handleDateChange,
    handleTitleChange,
    handleComparisonChange,
    handleRegionChange,
  } = props;
  const { data: liveTitleCondData, loading: condLoading } = useLiveTitleCond(gameTitle);
  const sharedCondFetch = Boolean(gameTitle);

  return (
    <div className='dbs-studio-filter'>
      <section className="dbg-studio-monthly-report-live-title-card-filter">
      
        <LiveMonthFilter
          {...{
            value: selectedDate,
            onChange: handleDateChange,
            overlayClassName: 'dbs-month-picker-overlay',
          }}
        />
        <LivePlatFormFilter
          {...{
            gameTitle,
            liveTitleCondData,
            sharedCondFetch,
            condLoading,
            value: selectedPlatforms,
            onChange: handleComparisonChange,
            boxClassName: 'dbs-metric-select-overlay',
          }}
        />
        <LiveRegionFilter
          {...{
            liveTitleCondData,
            sharedCondFetch,
            value: selectedRegion,
            onChange: handleRegionChange,
            boxClassName: 'dbs-metric-select-overlay dbc-region-select-container',
          }}
        />
        {/* <span style={{opacity: 0}}>
          <LiveTitleFilter
          {...{
            value: selectedTitle,
            onChange: handleTitleChange,
            boxClassName: 'dbs-metric-select-overlay',
          }}
        />
        </span> */}
      </section>
    </div>
  );
};

export default React.memo(Filter);
